@if (sameHeightElements) {
  <div class="children-same-height">
    @for (option of options; track option) {
      <button
        class="btn btn-secondary option"
        [ngClass]="{ active: option.val === control.value }"
        (click)="handleClick(option)"
      >
        @if (withInnerHTML) {
          <span [ngStyle]="{ textAlign: align }" class="wide-span" [innerHTML]="option.text"></span>
        }
        @if (!withInnerHTML) {
          <span [ngStyle]="{ textAlign: align }" class="wide-span">{{ option.text }}</span>
        }
        @if (option.tooltip && option.tooltip !== '') {
          <div
            #tooltip="matTooltip"
            (click)="tooltip.toggle(); $event.stopPropagation()"
            [matTooltip]="option.tooltip"
            class="info-icon"
            inlineSVG="/icons/icon-info.svg"
          ></div>
        }
      </button>
    }
  </div>
}
@if (!sameHeightElements) {
  <div class="layout">
    @for (option of options; track option) {
      <button
        class="btn btn-secondary option"
        [ngClass]="{ active: option.val === control.value }"
        (click)="handleClick(option)"
      >
        @if (withInnerHTML) {
          <span [innerHTML]="option.text"></span>
        }
        @if (!withInnerHTML) {
          <span>{{ option.text }}</span>
        }
        @if (option.tooltip && option.tooltip !== '') {
          <div
            #tooltip="matTooltip"
            (click)="tooltip.toggle(); $event.stopPropagation()"
            [matTooltip]="option.tooltip"
            class="info-icon"
            inlineSVG="/icons/icon-info.svg"
          ></div>
        }
      </button>
    }
  </div>
}
